




















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ArrowRightSvg from "@/assets/svg/arrow-right.svg";
import InformationSvg from "@/assets/svg/information.svg";
import BaseOverview, { Loadable } from "@/resources/components/BaseOverview.vue";
import ProgressBar from "@/resources/components/ProgressBar.vue";
import Project from "@/app/models/Project";
import ProductionOrder from "@/app/models/ProductionOrder";
import Cluster from "@/app/models/Cluster";
import { AxiosError } from "axios";
import PaginatedResponse from "@/app/models/Concerns/PaginatedResponse";
import Debounce from "@/app/support/Debounce";
import Station from "@/app/models/Station";
import ProgressMixin, { ProgressConfig } from "@/app/mixins/SampleMixin";
@Component({
    components: { BaseOverview, ArrowRightSvg, InformationSvg, ProgressBar },
    mixins: [ProgressMixin]
})
export default class Dashboard extends Vue {
    currentProductionOrder: ProductionOrder|null = null;
    cluster: Cluster|null = null;
    search: string = '';
    $refs!: { overview: BaseOverview }

    getProgress!: (total_brands: number) => ProgressConfig;

    get station(): Station|null {
        return this.$store.state.data.station;
    }

    get isScaffoldlessStation(): boolean {
        return this.station != null && this.station.is_scaffoldless_station === true;
    }

    @Watch('search')
    @Debounce(250)
    onSearchUpdated() {
        this.$refs.overview.reset();
    }

    @Watch('isScaffoldlessStation')
    onScaffoldlessStationChanged() {
        if (this.$refs.overview) {
            this.$refs.overview.reset();
        }
    }

    async loadItems(loadable: Loadable) {
        const Model = this.isScaffoldlessStation ? Project : ProductionOrder;
        
        // @ts-ignore
        const productionOrders: PaginatedResponse<Model> = await Model
            .open(loadable.page, { search: this.search })
            .catch((error: AxiosError) => {
                this.flash(this.$t('Whoops #' + error.response!.status));
                loadable.loadItems([]);
            });

        loadable.loadItems(productionOrders.data);

        // @ts-ignore
        if (productionOrders.station != null) {
            // @ts-ignore
            this.$store.commit('data/setStation', new Station(productionOrders.station));
        }
    }

    async beforeMount() {
        ProductionOrder.current().then(ProductionOrder => this.currentProductionOrder = ProductionOrder).catch((e) => {
            if (e?.response?.status === 404) {
                return;
            }
            throw e;
        });
        Cluster.current().then(cluster => this.cluster = cluster).catch((e) => {
            if (e?.response?.status === 404) {
                return;
            }
            throw e;
        });
    }
}
